import _classCallCheck from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
/* eslint-disable */
import { mix, clone, isString } from '@antv/util';
var Command = /*#__PURE__*/function () {
  function Command() {
    _classCallCheck(this, Command);
    this._cfgs = this.getDefaultCfg();
    this.list = [];
    this.queue = [];
  }
  _createClass(Command, [{
    key: "getDefaultCfg",
    value: function getDefaultCfg() {
      return {
        _command: {
          zoomDelta: .1,
          queue: [],
          current: 0,
          clipboard: []
        }
      };
    }
  }, {
    key: "get",
    value: function get(key) {
      return this._cfgs[key];
    }
  }, {
    key: "set",
    value: function set(key, val) {
      this._cfgs[key] = val;
    }
  }, {
    key: "initPlugin",
    value: function initPlugin(graph) {
      var _this = this;
      this.initCommands();
      graph.getCommands = function () {
        return _this.get('_command').queue;
      };
      graph.getCurrentCommand = function () {
        var c = _this.get('_command');
        return c.queue[c.current - 1];
      };
      graph.executeCommand = function (name, cfg) {
        _this.execute(name, graph, cfg);
      };
      graph.commandEnable = function (name) {
        return _this.enable(name, graph);
      };
    }
  }, {
    key: "registerCommand",
    value: function registerCommand(name, cfg) {
      if (this[name]) {
        mix(this[name], cfg);
      } else {
        var cmd = mix({}, {
          name: name,
          shortcutCodes: [],
          queue: true,
          executeTimes: 1,
          init: function init() {},
          enable: function enable() {
            return true;
          },
          execute: function execute(graph) {
            this.snapShot = graph.save();
            this.selectedItems = graph.get('selectedItems');
            this.method && (isString(this.method) ? graph[this.method]() : this.method(graph));
          },
          back: function back(graph) {
            graph.read(this.snapShot);
            graph.set('selectedItems', this.selectedItems);
          }
        }, cfg);
        this[name] = cmd;
        this.list.push(cmd);
      }
    }
  }, {
    key: "execute",
    value: function execute(name, graph, cfg) {
      var cmd = mix({}, this[name], cfg);
      var manager = this.get('_command');
      if (cmd.enable(graph)) {
        cmd.init();
        if (cmd.queue) {
          manager.queue.splice(manager.current, manager.queue.length - manager.current, cmd);
          manager.current++;
        }
      }
      graph.emit('beforecommandexecute', {
        command: cmd
      });
      cmd.execute(graph);
      graph.emit('aftercommandexecute', {
        command: cmd
      });
      return cmd;
    }
  }, {
    key: "enable",
    value: function enable(name, graph) {
      return this[name].enable(graph);
    }
  }, {
    key: "destroyPlugin",
    value: function destroyPlugin() {
      this._events = null;
      this._cfgs = null;
      this.list = [];
      this.queue = [];
      this.destroyed = true;
    }
  }, {
    key: "_deleteSubProcessNode",
    value: function _deleteSubProcessNode(graph, itemId) {
      var subProcess = graph.find('node', function (node) {
        if (node.get('model')) {
          var clazz = node.get('model').clazz;
          if (clazz === 'subProcess') {
            var containerGroup = node.getContainer();
            var subGroup = containerGroup.subGroup;
            var item = subGroup.findById(itemId);
            return subGroup.contain(item);
          } else {
            return false;
          }
        } else {
          return false;
        }
      });
      if (subProcess) {
        var group = subProcess.getContainer();
        var resultModel = group.removeItem(subProcess, itemId);
        graph.updateItem(subProcess, resultModel);
      }
    }
  }, {
    key: "initCommands",
    value: function initCommands() {
      var cmdPlugin = this;
      cmdPlugin.registerCommand('add', {
        enable: function enable() {
          return this.type && this.addModel;
        },
        execute: function execute(graph) {
          var item = graph.add(this.type, this.addModel);
          if (this.executeTimes === 1) this.addId = item.get('id');
        },
        back: function back(graph) {
          graph.remove(this.addId);
        }
      });
      cmdPlugin.registerCommand('update', {
        enable: function enable() {
          return this.itemId && this.updateModel;
        },
        execute: function execute(graph) {
          var item = graph.findById(this.itemId);
          if (item) {
            if (this.executeTimes === 1) this.originModel = mix({}, item.getModel());
            graph.update(item, this.updateModel);
          }
        },
        back: function back(graph) {
          var item = graph.findById(this.itemId);
          graph.update(item, this.originModel);
        }
      });
      cmdPlugin.registerCommand('delete', {
        enable: function enable(graph) {
          var mode = graph.getCurrentMode();
          var selectedItems = graph.get('selectedItems');
          return mode === 'edit' && selectedItems && selectedItems.length > 0;
        },
        method: function method(graph) {
          var selectedItems = graph.get('selectedItems');
          graph.emit('beforedelete', {
            items: selectedItems
          });
          if (selectedItems && selectedItems.length > 0) {
            selectedItems.forEach(function (i) {
              var node = graph.findById(i);
              if (node) {
                graph.remove(i);
              } else {
                cmdPlugin._deleteSubProcessNode(graph, i);
              }
            });
          }
          graph.emit('afterdelete', {
            items: selectedItems
          });
        },
        shortcutCodes: ['Delete', 'Backspace']
      });
      cmdPlugin.registerCommand('redo', {
        queue: false,
        enable: function enable(graph) {
          var mode = graph.getCurrentMode();
          var manager = cmdPlugin.get('_command');
          return mode === 'edit' && manager.current < manager.queue.length;
        },
        execute: function execute(graph) {
          var manager = cmdPlugin.get('_command');
          var cmd = manager.queue[manager.current];
          cmd && cmd.execute(graph);
          manager.current++;
        },
        shortcutCodes: [['metaKey', 'shiftKey', 'z'], ['ctrlKey', 'shiftKey', 'z']]
      });
      cmdPlugin.registerCommand('undo', {
        queue: false,
        enable: function enable(graph) {
          var mode = graph.getCurrentMode();
          return mode === 'edit' && cmdPlugin.get('_command').current > 0;
        },
        execute: function execute(graph) {
          var manager = cmdPlugin.get('_command');
          var cmd = manager.queue[manager.current - 1];
          if (cmd) {
            cmd.executeTimes++;
            cmd.back(graph);
          }
          manager.current--;
        },
        shortcutCodes: [['metaKey', 'z'], ['ctrlKey', 'z']]
      });
      cmdPlugin.registerCommand('copy', {
        queue: false,
        enable: function enable(graph) {
          var mode = graph.getCurrentMode();
          var items = graph.get('selectedItems');
          return mode === 'edit' && items && items.length > 0;
        },
        method: function method(graph) {
          var manager = cmdPlugin.get('_command');
          manager.clipboard = [];
          var items = graph.get('selectedItems');
          if (items && items.length > 0) {
            var item = graph.findById(items[0]);
            if (item) {
              manager.clipboard.push({
                type: item.get('type'),
                model: item.getModel()
              });
            }
          }
        }
      });
      cmdPlugin.registerCommand('paste', {
        enable: function enable(graph) {
          var mode = graph.getCurrentMode();
          return mode === 'edit' && cmdPlugin.get('_command').clipboard.length > 0;
        },
        method: function method(graph) {
          var manager = cmdPlugin.get('_command');
          this.pasteData = clone(manager.clipboard[0]);
          var addModel = this.pasteData.model;
          addModel.x && (addModel.x += 10);
          addModel.y && (addModel.y += 10);
          var _addModel$clazz = addModel.clazz,
            clazz = _addModel$clazz === void 0 ? 'userTask' : _addModel$clazz;
          var timestamp = new Date().getTime();
          var id = clazz + timestamp;
          addModel.id = id;
          var item = graph.add(this.pasteData.type, addModel);
          item.toFront();
        }
      });
      cmdPlugin.registerCommand('zoomIn', {
        queue: false,
        enable: function enable(graph) {
          var zoom = graph.getZoom();
          var maxZoom = graph.get('maxZoom');
          var minZoom = graph.get('minZoom');
          return zoom <= maxZoom && zoom >= minZoom;
        },
        execute: function execute(graph) {
          var manager = cmdPlugin.get('_command');
          var maxZoom = graph.get('maxZoom');
          var zoom = graph.getZoom();
          this.originZoom = zoom;
          var currentZoom = zoom + manager.zoomDelta;
          if (currentZoom > maxZoom) currentZoom = maxZoom;
          graph.zoomTo(currentZoom);
        },
        back: function back(graph) {
          graph.zoomTo(this.originZoom);
        },
        shortcutCodes: [['metaKey', '='], ['ctrlKey', '=']]
      });
      cmdPlugin.registerCommand('zoomOut', {
        queue: false,
        enable: function enable(graph) {
          var zoom = graph.getZoom();
          var maxZoom = graph.get('maxZoom');
          var minZoom = graph.get('minZoom');
          return zoom <= maxZoom && zoom >= minZoom;
        },
        execute: function execute(graph) {
          var manager = cmdPlugin.get('_command');
          var minZoom = graph.get('minZoom');
          var zoom = graph.getZoom();
          this.originZoom = zoom;
          var currentZoom = zoom - manager.zoomDelta;
          if (currentZoom < minZoom) currentZoom = minZoom;
          graph.zoomTo(currentZoom);
        },
        back: function back(graph) {
          graph.zoomTo(this.originZoom);
        },
        shortcutCodes: [['metaKey', '-'], ['ctrlKey', '-']]
      });
      cmdPlugin.registerCommand('resetZoom', {
        queue: false,
        execute: function execute(graph) {
          var zoom = graph.getZoom();
          this.originZoom = zoom;
          graph.zoomTo(1);
        },
        back: function back(graph) {
          graph.zoomTo(this.originZoom);
        }
      });
      cmdPlugin.registerCommand('autoFit', {
        queue: false,
        execute: function execute(graph) {
          var zoom = graph.getZoom();
          this.originZoom = zoom;
          graph.fitView(5);
        },
        back: function back(graph) {
          graph.zoomTo(this.originZoom);
        }
      });
      cmdPlugin.registerCommand('toFront', {
        queue: false,
        enable: function enable(graph) {
          var items = graph.get('selectedItems');
          return items && items.length > 0;
        },
        execute: function execute(graph) {
          var items = graph.get('selectedItems');
          if (items && items.length > 0) {
            var item = graph.findById(items[0]);
            item.toFront();
            graph.paint();
          }
        },
        back: function back(graph) {}
      });
      cmdPlugin.registerCommand('toBack', {
        queue: false,
        enable: function enable(graph) {
          var items = graph.get('selectedItems');
          return items && items.length > 0;
        },
        execute: function execute(graph) {
          var items = graph.get('selectedItems');
          if (items && items.length > 0) {
            var item = graph.findById(items[0]);
            item.toBack();
            graph.paint();
          }
        },
        back: function back(graph) {}
      });
    }
  }]);
  return Command;
}();
export default Command;